// Toolbar reset (snippets/filters.liquid, partial 'collection-filter-reset'). Rendered only while filters
// are on. Clears every filter control in the live form and submits it, so results refresh in place without
// a page load; the partial then re-renders without the button. The link's href is the no-JS fallback.
//
// Glitch in/out: it glitches in when filters first turn on. Live updates re-render the partial, so a
// swap (old removed, new added in the same task) is detected and skips both animations. When it's truly
// gone, a decorative copy is left at its last position in the toolbar to glitch out, then removed.
class SFilterReset extends HTMLElement {
  #ac;
  #row = null;
  #spot = null;

  connectedCallback() {
    this.#ac?.abort();
    this.#ac = new AbortController();
    const options = { signal: this.#ac.signal };
    this.#row = this.closest('[data-filter-toolbar]');

    if (this.#row?.dataset.resetShown === 'true') this.classList.add('filter-reset-static');
    if (this.#row) this.#row.dataset.resetShown = 'true';

    const measure = () => {
      if (!this.#row || !this.isConnected) return;
      const row = this.#row.getBoundingClientRect();
      const own = this.getBoundingClientRect();
      this.#spot = { left: own.left - row.left, top: own.top - row.top, width: own.width, height: own.height };
    };
    requestAnimationFrame(measure);
    window.addEventListener('resize', measure, options);
    this.addEventListener('pointerenter', measure, options);
    this.addEventListener('focusin', measure, options);

    this.addEventListener('click', (event) => {
      const link = event.target.closest('a');
      const form = this.closest('s-live-form')?.querySelector('form');
      if (!link || !form) return;
      event.preventDefault();
      measure();
      for (const control of form.elements) {
        if (!control.name?.startsWith('filter.')) continue;
        if (control.type === 'checkbox' || control.type === 'radio') control.checked = false;
        else control.value = '';
      }
      form.requestSubmit();
    }, options);
  }

  disconnectedCallback() {
    this.#ac?.abort();
    const row = this.#row;
    const spot = this.#spot;
    if (!row?.isConnected) return;
    const leaving = this.cloneNode(true);
    setTimeout(() => {
      // Re-rendered with filters still on: a new reset is already in place, nothing to animate.
      if (row.querySelector('s-filter-reset')) return;
      row.dataset.resetShown = 'false';
      if (!spot || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const ghost = document.createElement('div');
      ghost.className = 'filter-reset-ghost';
      ghost.setAttribute('aria-hidden', 'true');
      ghost.inert = true;
      ghost.style.cssText = `left:${spot.left}px;top:${spot.top}px;width:${spot.width}px;height:${spot.height}px`;
      ghost.append(...leaving.childNodes);
      row.append(ghost);
      ghost.addEventListener('animationend', () => ghost.remove(), { once: true });
      setTimeout(() => ghost.remove(), 800);
    }, 0);
  }
}

if (!customElements.get('s-filter-reset')) customElements.define('s-filter-reset', SFilterReset);
